import styled from "styled-components";

export const CalloutBanner = styled.div`
    display: flex;
    gap: 4px;
    align-items: flex-start;
    padding: 8px;
    background: ${({ theme }) => theme?.components?.callout_banner?.background};
    border-radius: 4px;
    margin-top: 16px;
`;